import { z } from "zod";
import { type FunctionObjectReturn } from "../utils";

/**
 * Schema for validating the request data for app check token creation.
 * Only requires the appId - authentication token will be obtained from Authorization header.
 */
export const GetSignedUrlSchema = z.object({
  /**
   * The Firebase App ID for which to create a token
   */
  filePath: z.string().min(1),
});

export type GetSignedUrlPostBody = z.infer<typeof GetSignedUrlSchema>;

/**
 * Type for App Check token response
 */
export interface GetSignedUrl {
  url: string;
}

export type GetSignedUrlResponse = FunctionObjectReturn<GetSignedUrl>;
